export const integrationConnectionsCacheKey = (
  workspaceId: string | undefined
) => ['integrationAuth', 'connections', workspaceId] as const;
